import React from 'react';
import { signedDocStatus, isSignedDocExpired } from '../services/api_firme';

const STYLES = {
  signed: { label: 'Firmato', className: 'bg-green-100 text-green-800 border border-green-500 font-semibold' },
  pending: { label: 'In attesa di firma', className: 'bg-yellow-100 text-yellow-700 border border-yellow-400 font-semibold' },
  not_sent: { label: 'Non inviato', className: 'bg-gray-200 text-gray-600 border border-gray-400 font-semibold' },
  expired: { label: '', className: '' },
  error: { label: 'Firma non riuscita', className: 'bg-red-100 text-red-800 border border-red-500 font-semibold' },
  rejected: { label: 'Firma rifiutata', className: 'bg-orange-100 text-orange-800 border border-orange-500 font-semibold' },
};

export default function FirmeStatusBadge({ doc }) {
  const status = signedDocStatus(doc);
  const isExpired = isSignedDocExpired(doc);

  const mainBadge = STYLES[status] || STYLES.pending;
  const expiredBadge = STYLES.expired;

  return (
    <div className="flex flex-col items-start">
      {/* STATO PRINCIPALE DELLA FIRMA */}
      <span className={`inline-flex items-center whitespace-nowrap rounded-full px-2.5 py-0.5 text-xs font-medium ${mainBadge.className}`}>
        {mainBadge.label}
      </span>
      {/* SCADENZA DEL DOCUMENTO */}
      {isExpired && (
        <span className={`inline-flex items-center whitespace-nowrap rounded-full px-2.5 py-0.5 text-xs font-medium ${expiredBadge.className}`}>
          {expiredBadge.label}
        </span>
      )}
    </div>
  );
}
